import * as React from 'react';
import { useState } from 'react';
import { RadioGroup } from '@headlessui/react';
import { Controller } from 'react-hook-form';
import { Control } from 'react-hook-form';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import classNames from 'styles/utils/classNames';

type Props = {
  errors: FieldErrors<any>;
  control: Control<any>;

  name: string;
  listHeader?: string;
  shouldRenderOthers?: boolean;
  otherInputPlaceholder?: string;
  options: {
    label: string | number;
    value: string | number;
  }[];

  isHideOther?: boolean;
  groupClassName?: string;
  invert?: boolean;
  labelClassName?: string;
};

const RadioList = ({
  control,
  name,
  options,
  errors,
  listHeader,
  shouldRenderOthers = false,
  otherInputPlaceholder = '',
  isHideOther = false,
  groupClassName = '',
  invert = false,
  labelClassName = '',
}: Props) => {
  const [otherValue, setOtherValue] = useState('');

  return (
    <div className="flex w-full flex-col">
      {listHeader && <span className="mb-2 font-bold">{listHeader}</span>}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, name, value } }) => (
          <RadioGroup value={value} name={name} onChange={onChange}>
            <div className={classNames(groupClassName || 'space-y-4')}>
              {options.map(({ value, label }, index) => {
                return (
                  <RadioGroup.Option key={index} value={value}>
                    {({ checked }) => (
                      <>
                        <div className="flex cursor-pointer items-center">
                          <div
                            className={classNames(
                              'flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ',
                              invert
                                ? 'border-color-border-hover-darkmode'
                                : 'border-color-border-input-lightmode',
                              checked
                                ? invert
                                  ? 'bg-color-bg-darkmode-brand'
                                  : 'bg-color-bg-lightmode-invert'
                                : 'dark:bg-color-bg-darkmode-primary',
                            )}
                          >
                            <div
                              className={classNames(
                                'h-2 w-2 rounded-full ',
                                invert
                                  ? 'bg-color-bg-darkmode-primary'
                                  : 'bg-color-bg-lightmode-primary dark:bg-color-bg-darkmode-primary',
                              )}
                            />
                          </div>
                          <div className="ml-3 flex flex-col">
                            <RadioGroup.Label
                              as="span"
                              className={classNames(
                                invert
                                  ? 'text-color-text-darkmode-secondary'
                                  : 'text-brand-gray-800',
                                labelClassName,
                              )}
                            >
                              {label}
                            </RadioGroup.Label>
                          </div>
                        </div>
                      </>
                    )}
                  </RadioGroup.Option>
                );
              })}
              {!isHideOther && (
                <RadioGroup.Option
                  value={otherValue}
                  onBlur={() => {
                    setOtherValue('');
                  }}
                >
                  {({ checked, active }) => {
                    return (
                      <>
                        {shouldRenderOthers && (
                          <div className="flex items-center">
                            <div
                              className={classNames(
                                'flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-color-border-input-lightmode',
                                checked
                                  ? 'bg-color-bg-lightmode-invert'
                                  : 'dark:bg-color-bg-darkmode-primary',
                              )}
                            >
                              <div className="h-2 w-2 rounded-full bg-color-bg-lightmode-primary dark:bg-color-bg-darkmode-primary" />
                            </div>
                            <div className="ml-3 flex flex-col">
                              <RadioGroup.Label as="span" className="text-brand-gray-800">
                                Other
                              </RadioGroup.Label>
                            </div>
                            <input
                              value={otherValue}
                              onChange={(e) => {
                                setOtherValue(e.target.value);
                                onChange(e.target.value);
                              }}
                              placeholder={otherInputPlaceholder}
                              className="border-2
    border-black bg-black accent-color-bg-darkmode-brand
    checked:border-color-bg-darkmode-brand checked:bg-color-bg-darkmode-brand
    hover:bg-black checked:hover:bg-color-bg-darkmode-brand focus:border-black focus:outline-none focus:ring-0
  "
                            />
                          </div>
                        )}
                      </>
                    );
                  }}
                </RadioGroup.Option>
              )}
            </div>
          </RadioGroup>
        )}
      />
    </div>
  );
};

export default RadioList;
